/* eslint-disable */
import createIcon from '../createIcon';

const IconLeftOutlined = createIcon({
  name: 'icon-left-outlined',
  content: '<path d="M273.490683 502.459627l318.012423 311.652174 44.521739-44.521739-267.130435-267.130435L636.024845 228.968944l-44.521739-44.521739z"/>',
  width: 1024,
  height: 1024
}, 'Icon');
export default IconLeftOutlined;
